import { GET_SERVICOS } from '../../constants';
import type { ServicosCategoria } from 'volto-ministerio-publico-federal/helpers/Servicos';

export interface ServicosPastaState {
  error: unknown;
  categorias: ServicosCategoria[];
  loaded: boolean;
  loading: boolean;
}

export type ServicosState = Record<string, ServicosPastaState>;

const vazio: ServicosPastaState = {
  error: null,
  categorias: [],
  loaded: false,
  loading: false,
};

export const servicosReducer = (
  state: ServicosState = {},
  action: {
    type?: string;
    pastaPath?: string;
    result?: { categorias?: ServicosCategoria[] };
    error?: unknown;
  } = {},
): ServicosState => {
  const { pastaPath } = action;
  if (!pastaPath) return state;
  const atual = state[pastaPath] ?? vazio;

  switch (action.type) {
    case `${GET_SERVICOS}_PENDING`:
      return {
        ...state,
        [pastaPath]: { ...atual, error: null, loading: true },
      };

    case `${GET_SERVICOS}_SUCCESS`:
      return {
        ...state,
        [pastaPath]: {
          error: null,
          categorias: action.result?.categorias ?? [],
          loaded: true,
          loading: false,
        },
      };

    case `${GET_SERVICOS}_FAIL`:
      return {
        ...state,
        [pastaPath]: {
          ...atual,
          error: action.error,
          loaded: false,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default servicosReducer;
